<template>
  <v-theme-provider :dark="dark">
    <div>
     <v-img
        class="logo"
        :src="require('@/assets/icons/soeko_white.png')"
        contain
      />

      <base-body>
       {{ $t('sections.hero.description') }}
      </base-body>

      <!-- <base-btn
        class="mb-12"
        color="white"
        outlined
      >
        More Info
      </base-btn> -->
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [],
    }),
  }
</script>
<style lang="scss" scoped>
.logo{
  height: 60px;
  width: 200px;
  max-width: unset;
  margin: 0 0 15px 10px;
}
.base-body{
  box-sizing: border-box;
  padding-left: 10px;
}
</style>
